import { render } from "./NovedadCard.vue?vue&type=template&id=30fed719&scoped=true"
import script from "./NovedadCard.vue?vue&type=script&lang=js"
export * from "./NovedadCard.vue?vue&type=script&lang=js"

import "./NovedadCard.vue?vue&type=style&index=0&id=30fed719&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fed719"]])

export default __exports__